import '../jquery-plugins/form-validation';

$(function () {
    $('form').validate();
});
